import { transformEventItems } from "$lib/utilities/calendar";
import { groupEventsByDay } from "$lib/utilities/eventSchedule";
import { isAfterDay } from "../eventDate";

export let resizeParams = {};

export const EPL_FORM_FACTORS = {
  GRID: "Calendar Grid",
  LIST: "Calendar List",
  SCHEDULE: "Event Schedule"
};

const PAST_EPL_MAX_ITEMS = 3;

export const isPastEvent = (item, todaysDate) =>
  isAfterDay(todaysDate, item.fields?.end || item.fields?.start);

export const getThemedItemIds = (themeObject) => {
  if (themeObject) {
    return themeObject.map((themedItem) => {
      return themedItem.sys?.id;
    });
  }
  return [];
};

/**
 * Removes excluded and featured items from the main list and filters events with out-of-range dates
 *
 * @param {*} items
 * @param {*} featuredItems
 * @param {*} excludedItems
 * @param {*} startDate
 * @param {*} endDate
 * @param {boolean} showPastItems keep only past events instead of only current/future ones
 * @returns
 */
export const filterListItems = ({
  items,
  featuredItems = [],
  excludedItems = [],
  startDate,
  endDate,
  todaysDate,
  showPastItems = false
}) => {
  return items.filter(
    (item) =>
      !excludedItems.some((excluded) => excluded.sys?.id === item.sys?.id) &&
      !featuredItems.some((featured) => featured.sys?.id === item.sys?.id) &&
      !(startDate && new Date(item.fields.start) < new Date(startDate)) &&
      !(endDate && new Date(item.fields.start) > new Date(endDate)) &&
      isPastEvent(item, todaysDate) === showPastItems
  );
};

export const transformListItems = ({
  items = [],
  themedItems = [],
  featuredItems = [],
  excludedItems = [],
  maxItems,
  startDate,
  endDate,
  showMonth,
  formFactor,
  todaysDate,
  showPastItems = false
}) => {
  // Limit to 1 featured item, keeping only past events for past EPLs and current/future events otherwise
  const featuredEvents = featuredItems
    .filter((item) => isPastEvent(item, todaysDate) === showPastItems)
    .map((item) => item.fields)
    .slice(0, 1);
  const featuredColumnCount = featuredEvents.length * 2;
  const filteredEvents = filterListItems({
    items,
    featuredItems,
    excludedItems,
    startDate,
    endDate,
    todaysDate,
    showPastItems
  });

  // Account for 2 columns if featured item exists. No maxItems limit for schedule view.
  let events;
  if (showPastItems) {
    // Past EPLs always show the 3 most recent events, newest first, so sort before slicing.
    events = filteredEvents
      .sort((a, b) => new Date(b.fields.start) - new Date(a.fields.start))
      .slice(0, PAST_EPL_MAX_ITEMS - featuredEvents.length)
      .map((item) => {
        return { ...item.fields, contentType: item.sys?.contentType?.sys?.id } || {};
      });
  } else {
    events = filteredEvents
      .slice(
        0,
        formFactor === EPL_FORM_FACTORS.SCHEDULE || !maxItems
          ? undefined
          : maxItems - featuredColumnCount
      )
      .map((item) => {
        return { ...item.fields, contentType: item.sys?.contentType?.sys?.id } || {};
      })
      .sort((a, b) => new Date(a.start) - new Date(b.start));
  }

  return {
    days: groupEventsByDay([...events, ...featuredEvents]),
    items: transformEventItems({
      items: events,
      themedItems,
      showMonth,
      formFactor,
      hideDates: showPastItems
    }),
    featuredItems: transformEventItems({
      items: featuredEvents,
      formFactor,
      hideDates: showPastItems
    })
  };
};
